/**
 * 应用市场链接单源（SPRINT_758 T-11776）。
 *
 * 河 2026-10-11 口径：App 上架前先写「应用市场的地址」，上架后把下面两个
 * 常量换成应用详情页链接（App Store：`apps.apple.com/cn/app/.../id<id>`；
 * 应用宝：`sj.qq.com/appdetail/<包名>`）——只改本文件，页面代码不动。
 */
export const APP_MARKET_LINKS = {
  /** App Store（中国区市场地址）；上架后换为应用详情页链接 */
  ios: "https://apps.apple.com/cn/",
  /** 应用宝（市场地址）；上架后换为应用详情页链接 */
  androidStore: "https://sj.qq.com/",
} as const
